import React from 'react';
import VideoSlide from '../../body/VideoSlide';
import { Text } from '@mantine/core';
import { Link } from 'react-router-dom';

const ChildCenteredTime = () => {
  return <VideoSlide vidSrc={1194418538}></VideoSlide>;
};

export default ChildCenteredTime;
